import BaseEvent from 'ol/events/Event';
import { GeoJSONFeature } from 'ol/format/GeoJSON';

export default class TickEvent extends BaseEvent {
  public selection: GeoJSONFeature;

  constructor(selection: GeoJSONFeature) {
    super('tick');
    this.selection = selection;
  }
}
